/*
 * @license
 * Copyright 2017 Google LLC All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const config = {
  "apiKey": "AIzaSyDa2QMr-GiBmrYmPYHrU0Li2f8xULbhLJ8",
  "appId": "1:646131991232:web:a907449a8cb9f844502325",
  "authDomain": "manandarji-testproject-2.firebaseapp.com",
  "databaseURL": "https://manandarji-testproject-2-default-rtdb.firebaseio.com",
  "messagingSenderId": "646131991232",
  "projectId": "manandarji-testproject-2",
  "storageBucket": "manandarji-testproject-2.firebasestorage.app"
}
